export default function headerTopHandler(headerTop) {
    const scrollPositon = window.scrollY;

    if (scrollPositon > 120) {
        headerTop.classList.add('fade-out');
    } else {
        headerTop.classList.remove('fade-out');
    }
}
